import { useEffect } from 'react'
import * as braze from '@braze/web-sdk'

const useBrazeInit = () => {
  useEffect(() => {
    braze.initialize(process.env.REACT_APP_BRAZE_KEY, {
      baseUrl: process.env.REACT_APP_BRAZE_URL
    })
  }, [])
  return null
}

export default useBrazeInit
